// La Fable by La Fontaine - Structured Data

export const companyInfo = {
  name: "La Fable by La Fontaine",
  address: "Kompagnistræde 11, 1208 København K",
  phone: "51 20 18 14",
  email: "Davide@lafable.dk",
  instagram: "https://www.instagram.com/lafablecph/",
  laFontaineInstagram: "https://www.instagram.com/lafontainecph/",
  laFontaineUrl: "https://www.lafontaine.dk/",
  facebook: "https://www.facebook.com/lafontaine.jazzklub",
  openingHours: [
    { days: "Mon-Thu", hours: "20:00-03:00" },
    { days: "Fri-Sat", hours: "20:00-05:00" },
    { days: "Sun", hours: "20:00-03:00" }
  ],
  popupHours: "Wed-Sun - From around 15:00 until midnight - weather permitting"
};

export const metadata = {
  home: {
    title: "La Fable | Wine Bar & Pop-Up by La Fontaine",
    description: "Experience La Fable, Copenhagen's elegant wine bar and pop-up by Denmark's oldest jazz club, La Fontaine. Discover natural wines, curated cocktails, and historic atmosphere."
  },
  wines: {
    title: "The Wine List | Curated Low-Intervention & Classic Wines | La Fable",
    description: "Explore our living wine list curated by sommelier Davide Piccolo (WSET Diploma). Featuring natural, biodynamic, and classical masterpieces by the glass and from our cellar."
  },
  cocktails: {
    title: "The Cocktails | Handcrafted & Classic Cocktail Menu | La Fable",
    description: "Savor exceptional cocktails at La Fable. Our cocktail programme, led by William Bretlau, blends historic jazz club energy with refined, high-quality ingredients."
  },
  family: {
    title: "The Family | Our Story & Historic Heritage | La Fable",
    description: "Meet the passionate team behind La Fable and explore our deep connection to La Fontaine, Copenhagen's legendary jazz club with over 65 years of cultural heritage."
  },
  visitUs: {
    title: "Visit Us | Opening Hours, Location & Wine Club | La Fable",
    description: "Join us at Kompagnistræde 11 in the heart of Copenhagen. Find opening hours, contact details, and sign up for the exclusive La Fable Wine Club."
  }
};

export const menuCard = {
  wines: [
    {
      category: "Sparkling",
      items: [
        { name: "2023 Pet-Nat, Bidule", producer: "Moravia, Czech Republic", price: "95 / 475" },
        { name: "NV Tradition Brut, Sébastien Lefèvre", producer: "Champagne, France", price: "165 / 825" }
      ]
    },
    {
      category: "White",
      items: [
        { name: "2024 Racines Métisses, Laurent Barth", producer: "Alsace, France", price: "95 / 475" },
        { name: "2019 Riva Arsiglia, Giovanni Menti", producer: "Veneto, Italy", price: "105 / 525" },
        { name: "2021 Riesling Alte Reben, Weingut Eymann", producer: "Pfalz, Germany", price: "110 / 550" },
        { name: "2023 Mâcon-Davayé, Domaine de la Croix Senaillet", producer: "Burgundy, France", price: "130 / 650" }
      ]
    },
    {
      category: "Rosé",
      items: [
        { name: "2023 Tutto Anfora Rosato, La Ginestra", producer: "Tuscany, Italy", price: "100 / 500" }
      ]
    },
    {
      category: "Orange",
      items: [
        { name: "2024 Roditis Orange Natur, Tetramythos", producer: "Peloponnese, Greece", price: "130 / 650" }
      ]
    },
    {
      category: "Red",
      items: [
        { name: "NV Revolution Red Solera, Johannes Zillinger", producer: "Weinviertel, Austria", price: "95 / 475" },
        { name: "2023 Barbera ‘Brichat’, Osvaldo Barberis", producer: "Piemonte, Italy", price: "105 / 525" },
        { name: "2022 Lirac, Château de Montfaucon", producer: "Rhône Valley, France", price: "110 / 550" },
        { name: "2019 Toreye Spätburgunder, Weingut Eymann", producer: "Pfalz, Germany", price: "125 / 625" }
      ]
    },
    {
      category: "Sweet",
      items: [
        { name: "2024 Jurançon, Domaine Castera", producer: "Jurançon, France", price: "135 / 675" }
      ]
    },
    {
      category: "Coravin picks",
      items: [
        { name: "2022 Los Frontones Blanco, Piedra Fluida", producer: "Canary Islands, Spain", price: "165 / 800" },
        { name: "2019 Gevrey-Chambertin 1. Cru ‘La Romanée’, Domaine des Varoilles", producer: "Burgundy, France", price: "325 / 1600" }
      ]
    }
  ],
  exclusiveWines: [
    {
      category: "Sparkling",
      items: [
        { name: "NV Cuvée No. 422 Extra Brut", producer: "Weingut Eymann, Pfalz, Germany", price: "650" },
        { name: "NV Grand Cru Avize, Blanc de Blancs", producer: "De Sousa et Fils, Champagne, France", price: "1000" },
        { name: "2019 Grand Cru Oger, Blanc de Blancs", producer: "Marguet et Fils, Champagne, France", price: "1200" },
        { name: "2018 Grand Cru Avize, Blanc de Blancs", producer: "Marguet et Fils, Champagne, France", price: "1200" },
        { name: "2015 Cuvée Boz, Blanc de Blancs", producer: "Sugrue South Downs, Sussex, England", price: "1200" },
        { name: "2011 Sonate, Extra Brut Nature", producer: "Fleury Père et Fils, Champagne, France", price: "1200" },
        { name: "NV Rosé de Saignée", producer: "Alessandra Divella, Franciacorta, Italy", price: "1250" },
        { name: "2008 Boléro, Blanc de Noirs", producer: "Fleury Père et Fils, Champagne, France", price: "1350" },
        { name: "2015 La Grande Année", producer: "Bollinger, Champagne, France", price: "1500" }
      ]
    },
    {
      category: "White",
      items: [
        { name: "2023 Sauvignon Blanc ‘Wild Air’", producer: "Storm Wines, Hemel-en-Aarde, South Africa", price: "650" },
        { name: "2022 Veltlínské Zelené Skalky", producer: "Vino Loigi, Moravia, Czech Republic", price: "700" },
        { name: "2021 Cuvée Origine Blanc", producer: "Plume, Jura, France", price: "750" },
        { name: "2022 Cartology", producer: "Alheit Vineyards, Western Cape, South Africa", price: "750" },
        { name: "2024 Rufo", producer: "Domaine Matassa, Roussillon, France", price: "800" },
        { name: "2022 Los Frontones Blanco", producer: "Piedra Fluida, Canary Islands, Spain", price: "800" },
        { name: "2023 La Fuye Blanc", producer: "Domaine Myosotis, Loire Valley, France", price: "900" },
        { name: "2022 Carricante ‘Vigna di Milo’", producer: "I Vigneri - Salvo Foti, Etna, Sicily", price: "950" },
        { name: "2019 Chablis 1. Cru 'Fourchaume · Les Vaupulans'", producer: "Guillaume Vrignaud, Burgundy, France", price: "950" },
        { name: "2022 Lunatica", producer: "Il Torchio, Liguria, Italy (orange)", price: "950" },
        { name: "2022 Riesling Scharzhof", producer: "Egon Müller, Mosel, Germany", price: "1000" },
        { name: "2024 Skerpioen", producer: "Eben Sadie, Swartland, South Africa", price: "1100" },
        { name: "2018 Vinha Centenaria", producer: "Azores Wine Company, Azores, Portugal", price: "1150" },
        { name: "2021 Chiesa Nera Blanc", producer: "Clos Venturi, Corsica, France", price: "1250" },
        { name: "2018 Meursault ‘Terres Blanches’", producer: "Pierre Morey, Burgundy, France", price: "1250" },
        { name: "2018 Pernand-Vergellesses 1. Cru", producer: "Domaine Chandon de Brailles, Burgundy, France", price: "1300" },
        { name: "2009 Clos de la Coulée de Serrant", producer: "Nicolas Joly, Loire Valley, France", price: "1350" },
        { name: "2014 Riesling Landgeflecht", producer: "Peter Jakob Kühn, Rheingau, Germany", price: "1400" },
        { name: "2008 Clos de la Coulée de Serrant", producer: "Nicolas Joly, Loire Valley, France", price: "1400" },
        { name: "2004 Clos de la Coulée de Serrant", producer: "Nicolas Joly, Loire Valley, France", price: "1450" },
        { name: "2015 Pessac-Léognan Blanc", producer: "Domaine de Chevalier, Bordeaux, France", price: "1600" }
      ]
    },
    {
      category: "Red",
      items: [
        { name: "2023 Bourgogne ‘Les Genévrières’", producer: "Domaine Frédéric Esmonin, Burgundy, France", price: "725" },
        { name: "2021 Cuvée Origine Rouge", producer: "Plume, Jura, France", price: "750" },
        { name: "2023 Cuvée Romanissa", producer: "Domaine Matassa, Roussillon, France", price: "800" },
        { name: "2020 Pinot Meunier", producer: "Matthiasson, Napa Valley, California, U.S.A.", price: "850" },
        { name: "2023 Rosso di Montalcino", producer: "Cerbaiona, Tuscany, Italy", price: "1000" },
        { name: "2021 Calderara Sottana", producer: "Girolamo Russo, Etna, Sicily, Italy", price: "1000" },
        { name: "2018 Beaune 1. Cru 'Le Bastion'", producer: "Domaine Chanson, Burgundy, France", price: "1000" },
        { name: "2024 Treinspoor", producer: "Eben Sadie, Swartland, South Africa", price: "1100" },
        { name: "2020 Marsannay ‘Clos de Jeu’", producer: "Domaine Charles Audoin, Burgundy, France", price: "1100" },
        { name: "2019 Shiraz ‘Balhannah Vineyard’", producer: "Shaw + Smith, Adelaide Hills, Australia", price: "1100" },
        { name: "2016 La Fleur de Rocheyron", producer: "Château Rocheyron, Bordeaux, France", price: "1100" },
        { name: "2007 Dits del Terra", producer: "Terroir al Límit, Priorat, Spain", price: "1100" },
        { name: "2023 Chiesa Nera Rouge", producer: "Clos Venturi, Corsica, France", price: "1200" },
        { name: "2019 Savigny-Lès-Beaune 'Aux Fournaux'", producer: "Domaine Chandon de Brailles, Burgundy, France", price: "1200" },
        { name: "2020 Barolo Villero", producer: "Oddero, Piemonte, Italy", price: "1350" },
        { name: "2023 Flor de Pingus", producer: "Dominio de Pingus, Ribera del Duero, Spain", price: "1600" },
        { name: "2019 Gevrey-Chambertin 1. Cru 'La Romanée'", producer: "Domaine des Varoilles, Burgundy, France", price: "1600" },
        { name: "1997 Volnay 1. Cru 'Les Santenots' Cuvée Gauvain", producer: "Morey-Blanc, Burgundy, France", price: "1600" },
        { name: "2001 Corton Grand Cru Cuvée Docteur Peste", producer: "Morey-Blanc, Burgundy, France", price: "1700" },
        { name: "2018 Barolo Vignarionda Riserva", producer: "Oddero, Piemonte, Italy", price: "1900" },
        { name: "2021 Brunello di Montalcino", producer: "Cerbaiona, Tuscany, Italy", price: "2000" }
      ]
    }
  ],
  snacks: [
    {
      category: "Drinks",
      items: [
        { name: "Venetian Spritz", price: "110", desc: "Select, Prosecco, Soda water" },
        { name: "Limoncello Spritz", price: "110", desc: "Limoncello, Prosecco, Soda water" },
        { name: "Americano", price: "115", desc: "Bitter, Vermouth Antica Formula, Soda water" },
        { name: "Negroni", price: "125", desc: "Bitter Carpano, Vermouth Antica Formula, Gin" },
        { name: "Moscow Mule", price: "95", desc: "Vodka, Lime Juice, Ginger Beer" },
        { name: "Paloma", price: "95", desc: "Tequila, Lime Juice, Grapefruit Soda" },
        { name: "Dark & Stormy", price: "95", desc: "Rum, Lime Juice, Ginger Beer" }
      ]
    },
    {
      category: "Snacks",
      items: [
        { name: "Mixed olives", price: "45", desc: "" },
        { name: "Smoked almonds", price: "40", desc: "" },
        { name: "Truffle crisps", price: "45", desc: "" }
      ]
    }
  ]
};
